import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import { MaintenanceNotification } from '../components/MaintenanceNotification';
import { useActivityHeartbeat } from '../hooks/useActivityHeartbeat';
import StudentRouteActivityTracker from '../components/StudentRouteActivityTracker';
import NotificationProvider from '../components/notifications/NotificationProvider';
import { isBugReporterDebugMode } from '../lib/bugReporter/debugMode';
import AppDocumentTitle from '../app/documentTitle/AppDocumentTitle';
import { PageTitleProvider } from '../app/documentTitle/PageTitleContext';

const BugReporterRoot = lazy(() => import('../components/BugReporter/BugReporterRoot'));

export default function LayoutRoot(): JSX.Element {
  useActivityHeartbeat();

  return (
    <NotificationProvider>
      <PageTitleProvider>
        <AppDocumentTitle />
        <StudentRouteActivityTracker />
        <AppLayout>
          <Outlet />
        </AppLayout>
      </PageTitleProvider>
      <MaintenanceNotification />
      {isBugReporterDebugMode() ? (
        <Suspense fallback={null}>
          <BugReporterRoot />
        </Suspense>
      ) : null}
    </NotificationProvider>
  );
}


